// React imports
import { useState } from 'react';

// Generic imports
import _ from 'lodash';
import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';

// Mui imports
import Box from '@mui/material/Box';
import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import CircularProgress from '@mui/material/CircularProgress';
import TextField from '@mui/material/TextField';

function CreateTemplateDialog(props) {
    const { onClose, offer, org, accesstoken, onOrgUpdated, opportunity } = props;
    const [ value, setValue ] = useState(offer.title || 'New Template');
    const [ creating, setCreating ] = useState(false);
    const [ error, setError ] = useState(false);
    const [ success, setSuccess ] = useState(false);

    const template = {
        type: 'opportunity',
        title: value || 'New Template',
        description: '',
        deleted: false,
        transportationMethods: [ opportunity.transportationMethod ],
        sections: offer.sections.map(s => {
            const fields = ((s.offers[0] || {}).fields || []).map(field => ({
                id: uuidv4(),
                title: field.title,
                type: field.type,
                currency: _.isEmpty(field.values) ? org.defaults?.currency : field.values[_.keys(field.values)[0]].currency,
            }));

            return {
                title: s.title,
                description: '',
                defaultCurrency: (fields[0] || {}).currency || org.defaults?.currency,
                fields
            }
        })
    };

    async function onOK() {
        setCreating(true);
        setError(false);
        setSuccess(false);

        try {
            const f = _.cloneDeep(org.forms);
            const { data: newId } = await axios.post(`/api/organizations/${org.id}/forms?accesstoken=${accesstoken}`, template);
            f[newId] = _.cloneDeep(template);
            f[newId].deleted = false;
            onOrgUpdated({ ...org, forms: f });
            setSuccess(true);
            return;
        } catch(e) {
            setCreating(false);
            setError(true);
            return;
        }
    }

    if (success) {
        return (
            <Dialog open={true} onClose={onClose}>
                <DialogTitle>
                    Create Opportunity Template from Offer
                </DialogTitle>
                <DialogContent>
                    <Alert severity='success'>
                        Template created successfully!
                    </Alert>
                </DialogContent>
                <DialogActions>
                    <Button variant='contained' color='primary' onClick={onClose}>
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }

    return (
        <Dialog open={true} onClose={onClose}>
            <DialogTitle>
                Create Opportunity Template from Offer
            </DialogTitle>
            <DialogContent>
                <Box sx={{ marginBottom: '12px' }} >
                    Enter title for your template:
                </Box>
                <TextField
                    fullWidth
                    value={value}
                    onChange={e => setValue(e.target.value)}
                    disabled={creating}
                />
                {creating && (
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: '24px' }}>
                        <CircularProgress />
                    </Box>
                )}
                {error && (
                    <Alert severity='error' sx={{ marginTop: '12px' }}>
                        Error creating template. Please try again later.
                    </Alert>
                )}
            </DialogContent>
            <DialogActions>
                <Button variant='outlined' color='secondary' onClick={onClose} disabled={creating}>
                    Cancel
                </Button>
                <Button variant='contained' color='primary' onClick={onOK} disabled={creating}>
                    OK
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default CreateTemplateDialog;
